/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 09 2024
 **/

import { css } from "@emotion/react";

export const DrawingContainerStyle = css`
	position: absolute;
	top: 60px;
	left: 0;
	width: 100%;
	height: calc(100% - 60px);
	z-index: 15;
	background-color: white;
	pointer-events: auto;
	transform: none;

	& canvas {
		width: 100%;
		height: 100%;
		cursor: none;
		background-color: #fff;
	}

	&.close {
		visibility: hidden;
	}

	&.minimize {
		position: absolute;
		width: 560px;
		height: 350px;
		top: 50%;
		left: 50%;
		background-color: #333;
		padding: 40px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;

		& canvas {
			width: 100% !important;
			height: 100% !important;
			border-radius: 5px;
			pointer-events: none;
		}
	}

	&.presentation,
	&.screen {
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: transparent;

		canvas {
			background-color: transparent;
		}

		&.minimize {
			left: 50%;
			top: 50%;
			padding: 0;
			border-radius: 0;

			canvas {
				pointer-events: none;
			}
		}
	}
`;
